import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    hasPendingChanges: false,
    showModal: false,
};
const pendingChangesSlice = createSlice({
    name: 'pendingchanges',
    initialState,
    reducers: {
        add(state) {
            state.hasPendingChanges = true;
        },
        addBlock(state) {
            state.hasPendingChanges = true;
            state.showModal = true;
        },
        remove(state) {
            Object.assign(state, initialState);
        },
    },
});
export const { add, addBlock, remove } = pendingChangesSlice.actions;
export default pendingChangesSlice.reducer;
